<template>
  <el-dialog
    v-model="loginVisible"
    :width="isMobile ? '100%' : '50%'"
    :before-close="handleClose"
    append-to-body
    align-center
  >
    <template #header>
      <div class="login-title">第三方账号登录</div>
    </template>
    <div class="login-content" v-loading="loading">
      <el-tooltip
        v-for="loginConfig in loginConfigList"
        :key="loginConfig.id"
        :content="loginConfig.source"
        placement="bottom"
      >
        <svg-icon
          :icon-name="loginConfig.loginIcon"
          @click="handleTypeLogin(loginConfig.source)"
          class="third-icon"
        />
      </el-tooltip>
    </div>
    <router-link :to="'/login?redirect=' + route.path">
      <el-link class="login-username">账号密码登录 >> </el-link>
    </router-link>
  </el-dialog>
</template>
<script setup>
import { computed, ref, watch } from 'vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'

import { list as listConfig } from '@/api/system/third/login'
import { getLoginUrl } from '@/api/auth/login'
import { setLoginRedirectPath } from '@/utils/auth'

const store = useStore()
const route = useRoute()

const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  }
})
watch(props, (newProps) => {
  loginVisible.value = newProps.visible
  getData()
})

// 是否移动端
const isMobile = computed(() => store.getters['app/isMobile'])
const loginVisible = ref(props.visible)
const loading = ref(true)
const loginConfigList = ref([])

async function getData() {
  if (!loginVisible.value) {
    return
  }
  loading.value = true
  const { data } = await listConfig()
  loginConfigList.value = data
  loading.value = false
}

const emit = defineEmits(null)
function handleClose() {
  emit('close')
}

/**
 * 第三方登录
 */
async function handleTypeLogin(source) {
  loading.value = true
  // 记录跳转地址，后续做跳转
  setLoginRedirectPath(route.path)
  const {
    data: { url }
  } = await getLoginUrl(source)
  window.location.href = url
  loading.value = false
}

getData()
</script>
<style lang="scss" scoped>
.login-title {
  text-align: center;
  font-size: 23px;
  font-weight: bold;
  color: #555;
  border-bottom: 1px solid #dcdfe6;
  padding-bottom: 10px;
}
.login-content {
  width: 100%;
  text-align: center;
  height: 50px;

  .third-icon {
    height: 35px;
    width: 35px;
    border-radius: 50%;
    margin-right: 10px;
  }
}
.login-username {
  float: right;
}
</style>
